

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// Material helpers
import { withRouter } from 'react-router-dom';
import { forwardRef } from 'react';
// Shared components

import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
import 'react-perfcascade/dist/react-perfcascade.css';
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import styles from './styles';
import { withStyles } from '@material-ui/core/styles';

import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
// Component styles
import { api_host, api_auth } from './../../../../common/globals/constants';
import moment from 'moment'
import 'moment/locale/es'
import Hours from './../../../../helpers/Hours';
import HoursEdit from './../../../../helpers/HoursEdit';
import {getHoursList} from './../../../../services/getHoursList';
import PerfectScrollbar from 'react-perfect-scrollbar';
moment.locale('es')
const dateMoment=((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};
const sendValues = (nombre, descripcion, token, user, horarioId) => {

    return new Promise(resolve => {
        setTimeout(() => {
        fetch(api_host+`/reporte/general/horarios_habiles/?token=${token}&start=${new Date().getTime()}`, {
            method: 'DELETE', // or 'PUT'
            body: JSON.stringify({token: token, nombre: nombre, descripcion: descripcion, cliente_id: user, horario_id: horarioId}), // data can be `string` or {object}!
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => res.json())
            .catch(error => console.error('Error:', error))
            .then(response => {
                if (response.status == 1) {
                    resolve(false);
                } else {
                    resolve(true);
                }
            }
            );
        }, 100);
    });
};

class BusinessHours extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            isLoad:true,
            objective:this.props.objective,
            nodes:this.props.nodes,
            steps:this.props.steps,
            begin:this.props.dateBegin,
            final:this.props.dateFinal,
            dates:null,
            modalOpen:false,
            //onClose:this.props.onClose,
            completed: false,
            open: false,
            values:{
                name: ''
            },
            openSnack: false,
            isValid: false,
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.dateBegin !== state.begin||props.dateFinal!==state.final) {
            return {
                isLoad:true,
                begin:props.dateBegin,
                final:props.dateFinal,
                dates:null
            }
        }
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if(prevState.open !== this.state.open || prevState.editEl !== this.state.editEl){
            this.processData();
        }
    }

    componentDidMount() {
        this.processData();
    }

    getFetchs = (user, token, type) =>{         
        var getData = getHoursList(user, token, type)           
        getData.then( data =>  { 
            this.setState({
                isLoad:false,
                data:data
            })
        })      
        
    }
   
    processData = () => {
        const { objective, begin, final} = this.state
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        let type = 5
        this.getFetchs(user, token, type)
    }

    /*setOpen = (audio) => {
        this.setState({
            modalOpen : true,
            modalClose : false,
            setAudio : audio,
        })
    }
    setCloseModal=()=>{
        this.setState({
            modalOpen : false,
            modalClose : true,
            setAudio : null
        })
    }*/

    onOpenModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    handleShowEdit = (event, value) => {
        this.setState({
            editEl: event.currentTarget,
            valuesEdit: value
        });
    };

    onCloseModalEdit = () => {
        this.setState({ editEl: null });
    };

    handleShowDelete = (event, value) => {
        this.setState({
            deleteEl: event.currentTarget,
            values:{
                name: value.nombre,
                descripcion: value.descripcion,
                horarioId: value.horario_id
            }
        });
    };

    handleCloseDelete = () => {
        this.setState({
            deleteEl: null
        });
    };

    handleDeleted = async(value) => {
        const {addEl, editEl, values} = this.state;
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('client_id')
        try {
            this.setState({ isLoading: true });
            var ok = await sendValues(values.nombre, values.descripcion, token, user, values.horarioId);
            if (ok){
                this.setState({
                    isLoading: true,
                    isValid: true,                   
                    open: false,
                    deleteEl: null,
                    openSnack: true,

                });
                this.processData();
            } else {
                this.setState({
                    isLoading: false,
                    isValid: false,                   
                    open: false,
                    openSnack: true,
                });
                
            }

        } catch (error) {
            this.setState({
                isLoading: false,
                //serviceError: error,
                isValid: false,
                open: false,
                openSnack: true,
            });
        }
    }
    handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            openSnack: false 
        })
    };
    handleOpenSnack = (reason) => {
        if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            openSnack: true,
            isValid: reason 
        })
    };

    render() {

        const { isLoad, data, steps, objective, modalOpen, onClose, completed, open, editEl, valuesEdit, deleteEl, values, openSnack, isValid} = this.state;
        const { classes } = this.props;
        const showModal = Boolean(open); 
        const showModalEdit = Boolean(editEl); 
        const showDeleteEl = Boolean(deleteEl);
        return(<Portlet>
                <PortletHeader style={{backgroundColor:'#6d6d6d', color:'white'}}>
                    
                    <Button 
                        key="close" 
                        aria-label="close" 
                        //style={{color:"white", float:"right"}}
                            onClick={this.onOpenModal}>
                                <Typography style={{color:"white"}}>{this.props.t('businessHours.addButton')}</Typography>
                    </Button>
                </PortletHeader>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={open}
                    onClose={this.onCloseModal}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >                                    
                    <Fade in={showModal}>
                        <div className={classes.modal}>
                            <Hours closeModal={this.onCloseModal} handleCloseSnack={this.handleCloseSnack} 
                                        handleOpenSnack={this.handleOpenSnack}  horarioTipo={data ? data[0]['horario_tipo']: null}></Hours>
                        </div>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={editEl}
                    onClose={this.onCloseModalEdit}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >                                    
                    <Fade in={showModalEdit}>
                        <div className={classes.modal}>
                            <HoursEdit closeModal={this.onCloseModalEdit} data={valuesEdit} handleCloseSnack={this.handleCloseSnack} handleOpenSnack={this.handleOpenSnack}></HoursEdit>
                        </div>
                    </Fade>
                </Modal>
                    { data == null  ? 
                    <PortletContent style={{alignItems: 'center', position: 'absolute', top: '40%', left: '50%'}}>
                        <PerfectScrollbar>
                            <Typography
                            variant="h5"
                            align="center"
                            >
                            <CircularProgress
                            variant="indeterminate"
                            size={24}
                            thickness={4}
                            />
                            <br/>
                                {this.props.t('businessHours.loading')}
                            </Typography>
                        </PerfectScrollbar>
                    </PortletContent>
                :<div style={{ maxWidth: "100%", backgroundColor: '#e7e7e7' }}>
                    {/*<Button style={{backgroundColor: 'white'}} variant="outlined" color="primary" size="small">
                        <Typography variant="button"> Agregar contacto </Typography>
                    </Button>*/}
                    <MaterialTable
                        icons={tableIcons}
                        columns={[
                                                        { width: 100, title: this.props.t('businessHours.table.nombre'), field: "nombre"/*, defaultGroupOrder: 0*/,headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                              } },
                                                        { width: 100, title: this.props.t('businessHours.table.descripcion'), field: "descripcion" ,headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                              } },
                                                        { width: 100, title: this.props.t('businessHours.table.id'), field: "horario_id"/*, type: "numeric"*/ ,headerStyle: {
                                backgroundColor: '#979797',
                                color: '#353535'
                                }, hidden: true },
                                                        { width: 100, title: this.props.t('businessHours.table.editar'), field: "editar"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#979797',
                                color: '#353535'
                              }, hidden: true },
                                                        { width: 100, title: this.props.t('businessHours.table.eliminar'), field: "eliminar"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#979797',
                                color: '#353535'
                              }, hidden: true},
                            
                        ]}
                        data={data} 
                        title={this.props.t('businessHours.table.title')}
                        //title=" "
                        localization={{
                            grouping: {
                                groupedBy: this.props.t('businessHours.localization.groupedBy'),
                                placeholder: this.props.t('businessHours.localization.groupingPlaceholder'),
                            },
                            body: {
                                emptyDataSourceMessage: this.props.t('businessHours.localization.body.emptyDataSourceMessage')
                            },
                            toolbar: {
                                searchTooltip: this.props.t('businessHours.localization.toolbar.searchTooltip'),
                                searchPlaceholder: this.props.t('businessHours.localization.toolbar.searchPlaceholder')
                            },
                            pagination: {
                                labelRowsSelect: this.props.t('businessHours.localization.pagination.labelRowsSelect'),
                                labelDisplayedRows: this.props.t('businessHours.localization.pagination.labelDisplayedRows'),
                                firstTooltip: this.props.t('businessHours.localization.pagination.firstTooltip'),
                                previousTooltip: this.props.t('businessHours.localization.pagination.previousTooltip'),
                                nextTooltip: this.props.t('businessHours.localization.pagination.nextTooltip'),
                                lastTooltip: this.props.t('businessHours.localization.pagination.lastTooltip')
                            },
                            header: {
                                actions: '',
                                headerStyle: {
                                    backgroundColor: '#0c0033',
                                    color: '#0c0033'

                                }
                            },
                        }}
                        options={{
                            grouping: true,
                            actionsColumnIndex: -1,
                            headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                            }
                        }}
                        actions={[
                            /*{
                                icon: AddCircleOutlineIcon,
                                tooltip: 'Agregar contacto',
                                isFreeAction: true,
                                //onClick: (event) => alert("You want to add a new row")
                                onClick: props.handleShowAdd
                            },*/
                            rowData => ({
                                icon: Edit,
                                tooltip: this.props.t('businessHours.actions.editTooltip'),
                                //props.handleFieldChange('name', event.target.value)
                                //onClick: (event, rowData) => alert("You saved " + rowData.nombre)
                                onClick: (event, rowData) => this.handleShowEdit(event, rowData),
                                disabled: rowData.asociado,
                                hidden: rowData.asociado
                            }),
                            
                            rowData => ({
                                icon: DeleteOutline,
                                tooltip: this.props.t('businessHours.actions.deleteTooltip'),
                                onClick: (event, rowData) => this.handleShowDelete(event, rowData),
                                disabled: rowData.asociado,
                                hidden: rowData.asociado
                            })
                        ]}
                    />
                </div>
                }
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={showDeleteEl}
                    onClose={this.handleCloseDelete}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >                                    
                    <Fade in={showDeleteEl}>
                        <div className={classes.modalDeleted}>                             
                            <Portlet
                                //className={rootClassName}
                            >
                                
                                <PortletLabel
                                    className={classes.portletFooterTwo}
                                    //subtitle="Actualizar Contraseña"
                                    title={this.props.t('businessHours.deleteConfirm', { name: values.name })}
                                />
                                
                                
                                <PortletFooter className={classes.portletFooterTwo} align="center" >
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        onClick={this.handleDeleted}
                                    >
                                        {this.props.t('businessHours.confirm.accept')}
                                    </Button><>&nbsp;</> <>&nbsp;</> <>&nbsp;</>
                                    <Button
                                        color="primary"
                                        variant="outlined"
                                        onClick={this.handleCloseDelete}
                                    >
                                        {this.props.t('businessHours.confirm.cancel')}
                                    </Button>
                                </PortletFooter>
                            </Portlet>                          
                        </div>
                    </Fade>
                </Modal>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={openSnack}
                    autoHideDuration={6000}
                    onClose={this.handleCloseSnack}
                    >
                    <SnackbarContent
                        className={isValid ? classes.snackContentOk
                                    : classes.snackContent}
                        aria-describedby="client-snackbar"
                                    message={
                            isValid ?
                                <span id="client-snackbar" className={classes.message}>
                                    <CheckCircleIcon className={(classes.icon, classes.iconVariant)}/>
                                    {this.props.t('businessHours.snackbar.success')}
                                </span>
                            :	<span id="client-snackbar" className={classes.message}>
                                    <ErrorIcon className={(classes.icon, classes.iconVariant)}/>
                                    {this.props.t('businessHours.snackbar.error')}
                                </span>
                        }
                        action={[
                            <IconButton key="close" aria-label="close" color="inherit" onClick={this.handleCloseSnack}>
                                <CloseIcon className={classes.icon}/>
                            </IconButton>
                        ]}
                    />
                </Snackbar>
            </Portlet>
        ) 
    }
}



export default compose(withRouter, withStyles(styles), withTranslation())(BusinessHours);